import React from "react";
import {Divider, Grid, Header, Icon, Segment} from "semantic-ui-react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import ImportRequest from "../model";
import ShowLines from "./showLines";


function DefaultValidationError({
    name
}) {
    return name;
}

DefaultValidationError.propTypes = {
    name: PropTypes.string.isRequired,
};

function ErrorDetails({
    errors,
    validationError,
}) {
    const ValidationError = validationError || DefaultValidationError;
    return(
        <Segment>
            <Grid columns={ 3 } celled="internally" >
                <Grid.Row >
                    <Grid.Column>
                        <Trans i18nKey="nacre.ImportController.analysis.header.error">Error</Trans>
                    </Grid.Column>
                    <Grid.Column>
                        <Trans i18nKey="nacre.ImportController.analysis.header.quantity">Quantity</Trans>
                    </Grid.Column>
                    <Grid.Column>
                        <Trans i18nKey="nacre.ImportController.analysis.header.line">Lines</Trans>
                    </Grid.Column>
                </Grid.Row>
                { Object.keys(errors).map(name => <Grid.Row
                    key={ name }
                >
                    <Grid.Column>
                        <ValidationError name={ name } />
                    </Grid.Column>
                    <Grid.Column >{ errors[name].length }</Grid.Column>
                    <Grid.Column >
                        <ShowLines lines={ errors[name] } />
                    </Grid.Column>
                </Grid.Row>
                ) }
            </Grid>
        </Segment>
    );
}
ErrorDetails.propTypes = {
    errors: PropTypes.object.isRequired,
    validationError: PropTypes.elementType,
};

function AnalysisLine({
    children,
    icon,
}) {
    return (
        <p>
            <Icon className="icon-weez" name={ icon } />
            <span className="text-details">
                { children }
            </span>
        </p>
    );
}
AnalysisLine.propTypes = {
    children: PropTypes.node.isRequired,
    icon: PropTypes.string.isRequired,
};

export default function ShowAnalysis({
    step,
    importRequest,
    validationError,
    showDetails,
    toggleDetails,
}) {
    const totalRowsCount = importRequest.countTotalRows();
    const errorRowsCount = importRequest.getInvalidSummary();
    const createdRowsCount = importRequest.getCreatedSummary();

    return(
        <React.Fragment>
            <Divider horizontal>
                <Header as="h5">
                    <Icon
                        className="icon-weez"
                        name={ step === 'import-process-confirm' ? 'file excel' : 'user plus' }
                    />
                    { step === 'import-process-confirm'
                        ? <Trans i18nKey="nacre.ImportController.analysis.summary.category_analysis">Analysis results</Trans>
                        : <Trans  i18nKey="nacre.ImportController.analysis.summary.category_import">Import results</Trans> }
                </Header>
            </Divider>
            <AnalysisLine icon="tasks">
                <Trans
                    i18nKey="nacre.ImportController.analysis.summary.total_line"
                    values={ { count: totalRowsCount } }
                    count={ totalRowsCount }
                >%count% treated lines</Trans>
            </AnalysisLine>
            <AnalysisLine icon="times circle outline">
                <Trans
                    i18nKey="nacre.ImportController.analysis.summary.invalid_line"
                    values={ { count: errorRowsCount } }
                    count={ errorRowsCount }
                >%count% invalid lines</Trans>
                { errorRowsCount
                    ?  <label className="details" onClick={ toggleDetails } >
                        <Trans i18nKey="nacre.ImportController.analysis.summary.details">Details</Trans>
                    </label>
                    : null}
            </AnalysisLine>
            { showDetails ? <ErrorDetails
                errors={ importRequest.getErrorGroups() }
                validationError={ validationError }
            /> : null }
            <AnalysisLine icon="check circle outline">
                <Trans
                    i18nKey="nacre.ImportController.analysis.summary.valid_line"
                    values={ { count: createdRowsCount } }
                    count={ createdRowsCount }
                >%count% valid lines</Trans>
            </AnalysisLine>
        </React.Fragment>
    );
}

ShowAnalysis.propTypes = {
    step: PropTypes.oneOf([
        'import-process-confirm',
        'import-process-done',
    ]),
    importRequest: PropTypes.instanceOf(ImportRequest).isRequired,
    validationError: PropTypes.elementType,
    showDetails: PropTypes.bool.isRequired,
    toggleDetails: PropTypes.func.isRequired,
};
